import React, { Component } from "react";
import PropTypes from "prop-types";
import ImageShare from "components/utility/images/ImageShare";
import { getDecodedHtml } from "utils/getDecodedHtml";

class ContentPageActionShareLite extends Component {
	handleCopy = (e) => {
		var textField = document.createElement("textarea");
		textField.setAttribute("class", "content-page-share-lite-temp-textarea");
		textField.setAttribute("readonly", "");
		textField.setAttribute("tabindex", "0");
		textField.innerText = this.props.shareUrl;
		e.target.appendChild(textField);

		textField.select();
		textField.setSelectionRange(0, 99999);
		document.execCommand("copy");
		textField.parentNode.removeChild(textField);

		let closestModal = document.getElementsByClassName("content-page-share-lite-modal-overlay");
		var node = document.createElement("div");
		node.classList.add("content-page-share-lite-copy-confirmed");
		var textnode = document.createTextNode(this.props.copyConfirm);
		node.appendChild(textnode);
		closestModal[0].appendChild(node);
		this.props.setCopyFlag(true);
	};
	render() {
		const {
			title = "",
			content = "",
			externalLinkTitle = "",
			copyLabel = "",
			shareUrl = ""
		} = this.props;
		return (
			<div className="content-page-share-lite">
				<p className="content-page-share-lite-title label-6-left-medium-cool-gray">
					<ImageShare /> {title}
				</p>
				<span
					className="body-3-left-almost-black content-page-share-lite-content"
					dangerouslySetInnerHTML={{ __html: getDecodedHtml(content) }}
				/>
				<p className="label-5-left-medium-cool-gray content-page-share-lite-external-link">
					{externalLinkTitle}
				</p>
				<div className="content-page-share-lite-link-container">
					<input
						type="text"
						disabled
						className="body-3-left-almost-black content-page-share-lite-link-link"
						value={shareUrl}
					/>
					<button
						className="content-page-share-lite-button coveo-custom-event-share"
						onClick={(e) => this.handleCopy(e)}
						aria-label={copyLabel}
					>
						{copyLabel}
					</button>
				</div>
			</div>
		);
	}
	static propTypes = {
		isDisable: PropTypes.bool,
		title: PropTypes.string,
		content: PropTypes.string,
		externalLinkTitle: PropTypes.string,
		copyLabel: PropTypes.string,
		shareUrl: PropTypes.string,
		copyConfirm: PropTypes.string
	};
}

export default ContentPageActionShareLite;
